import styled from 'styled-components';

export const UploadFeedbackWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  right: 12px;
  z-index: 9999;
`;
